import {
  Button,
  Checkbox,
  FormControlLabel,
  Select,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import { useSelector } from 'react-redux';
import { ExpandMore } from '@mui/icons-material';
import { useHook as EquipmentsDashboard } from '../../hardware/equipments/useHook';

interface FilterDrawer {
  fliterCloseDrawer: () => void;
  filterSubmit: (data: any) => void;
  filterDrawerData?: any;
}

const EquipmentFilter: React.FC<FilterDrawer> = ({
  fliterCloseDrawer,
  filterSubmit,
  filterDrawerData,
}) => {
  const { fetchGetListCategory } = EquipmentsDashboard();
  const { allCategory } = useSelector((state: any) => state.equipments);
  const [dealerName, setDealerName] = React.useState<string[]>([]);
  const [dealerModel, setDealerModel] = React.useState<string[]>([]);
  const [dealerCategory, setDealerCategory] = React.useState<string[]>([]);
  const [dealerSubcategory, setDealerSubcategory] = React.useState<string[]>(
    [],
  );
  const [filteredController, setFilteredController] = useState<any[]>([]);
  const [filteredModels, setFilteredModels] = useState<any[]>([]);
  const [filteredCategory, setFilteredCategory] = useState<any[]>([]);
  const [filteredSubCategory, setFilteredSubCategory] = useState<any[]>([]);
  const [filterStoreCategory, setFilterStoreCategory] = useState<any[]>([]);
  const [filterStoreSubCategory, setFilterStoreSubCategory] = useState<any[]>(
    [],
  );
  const [isFilterActive, setFilterActive] = useState(false);
  const { equipmentFilter } = useSelector((state: any) => state.equipments);

  //get Category
  const handleGetCategory = () => {
    const updateCategory = allCategory?.map(
      (data: { categoryName: any }) => data?.categoryName,
    );
    setFilteredCategory(updateCategory ? updateCategory : []);
    setFilterStoreCategory(updateCategory ? updateCategory : []);
  };

  //get SubCategory
  const handleGetSubCategory = async () => {
    // Filter based on exact match for the category name
    const upDateSubCategory = allCategory
      .filter(
        (category: { categoryName: any; subCategories: any }) =>
          dealerCategory.includes(category.categoryName) &&
          Array.isArray(category.subCategories),
      )
      .flatMap((category: { subCategories: any }) => category.subCategories);
    setFilteredSubCategory(upDateSubCategory ? upDateSubCategory : []);
    setFilterStoreSubCategory(upDateSubCategory ? upDateSubCategory : []);

    //subCategory selection values
    const selectSubCategory = upDateSubCategory?.filter((data: string) =>
      dealerSubcategory?.includes(data),
    );
    setDealerSubcategory(selectSubCategory ? selectSubCategory : []);
  };

  useEffect(() => {
    handleGetSubCategory();
  }, [dealerCategory]);

  useEffect(() => {
    if (allCategory?.length > 0) {
      handleGetCategory();
    }
  }, [allCategory]);

  useEffect(() => {
    if (!(allCategory?.length > 0)) {
      fetchGetListCategory({});
    }
  }, []);

  //setSelectionFilter
  useEffect(() => {
    if (filterDrawerData) {
      setDealerName(filterDrawerData?.controller);
      setDealerSubcategory(filterDrawerData?.subCategory);
      setDealerCategory(filterDrawerData?.category);
      setDealerModel(filterDrawerData?.models);
    }
  }, [filterDrawerData]);

  useEffect(() => {
    setFilteredController(
      equipmentFilter?.controller ? equipmentFilter?.controller : [],
    );
    setFilteredModels(equipmentFilter?.model ? equipmentFilter?.model : []);
  }, [equipmentFilter]);

  useEffect(() => {
    const isFilterActive =
      dealerName?.length > 0 ||
      dealerModel?.length > 0 ||
      dealerCategory?.length > 0 ||
      dealerSubcategory?.length > 0;

    setFilterActive(isFilterActive);
  }, [dealerName, dealerModel, dealerCategory, dealerSubcategory]);

  const handleFilterEquipment = () => {
    const payload = {
      controllerName: dealerName,
      model: dealerModel,
      category: dealerCategory,
      subcategory: dealerSubcategory,
    };
    filterSubmit(payload);
  };

  const handleControllerSearch = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const query = event.target.value.toLowerCase();
    const filtered = equipmentFilter?.controller?.filter((controller: string) =>
      controller?.toLowerCase().includes(query),
    );
    setFilteredController(filtered);
  };

  const handleCategorySearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value.toLowerCase();
    const filtered = equipmentFilter?.category?.filter((category: string) =>
      category?.toLowerCase().includes(query),
    );
    setFilteredCategory(filtered);
  };

  const handleSubCategorySearch = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const query = event.target.value.toLowerCase();
    const filtered = equipmentFilter?.subCategory?.filter((category: string) =>
      category?.toLowerCase().includes(query),
    );
    setFilteredSubCategory(filtered);
  };

  const handleFilterSelection = (
    selectName: string | undefined,
    field: string,
  ) => {
    if (!selectName) return;
    if (field === 'controller') {
      setDealerName((prevselected) => {
        if (prevselected.includes(selectName)) {
          const updatedData = prevselected.filter(
            (names) => names !== selectName,
          );
          return updatedData;
        } else {
          const updatedData = [...prevselected, selectName];
          return updatedData;
        }
      });
    } else if (field === 'models') {
      setDealerModel((prevselected) => {
        if (prevselected.includes(selectName)) {
          const updatedData = prevselected.filter(
            (names) => names !== selectName,
          );
          return updatedData;
        } else {
          const updatedData = [...prevselected, selectName];
          return updatedData;
        }
      });
    } else if (field === 'category') {
      setDealerCategory((prevselected) => {
        if (prevselected.includes(selectName)) {
          const updatedData = prevselected.filter(
            (names) => names !== selectName,
          );
          return updatedData;
        } else {
          const updatedData = [...prevselected, selectName];
          return updatedData;
        }
      });
    } else if (field === 'subCategory') {
      setDealerSubcategory((prevselected) => {
        if (prevselected.includes(selectName)) {
          const updatedData = prevselected.filter(
            (names) => names !== selectName,
          );
          return updatedData;
        } else {
          const updatedData = [...prevselected, selectName];
          return updatedData;
        }
      });
    }
  };

  const handleModelsSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value.toLowerCase();
    const filtered = equipmentFilter?.model?.filter((models: string) =>
      models?.toLowerCase().includes(query),
    );
    setFilteredModels(filtered);
  };
  return (
    <div className="fliter-drawer-container">
      <div>
        <div className="fliter-drawer-header">
          <p className="fliter-drawer-header-content">Fliters</p>
          {/* <p className="fliter-drawer-header-text">Restore</p> */}
        </div>
        <div className="fliter-drawer-body">
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Controller</p>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              displayEmpty
              value={dealerName}
              onClose={() => setFilteredController(equipmentFilter?.controller)}
              renderValue={() => {
                if (dealerName.length === 0) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Controller
                    </span>
                  );
                }
                return dealerName.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search Controller"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={handleControllerSearch}
                  />
                </div>
                <div className="selectoption_list_content">
                  {filteredController?.map((controller, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={dealerName.includes(String(controller))}
                            onChange={() => {
                              handleFilterSelection(
                                String(controller),
                                'controller',
                              );
                            }}
                          />
                        }
                        label={controller}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Model</p>
            <Select
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              displayEmpty
              value={dealerModel}
              onClose={() => setFilteredModels(equipmentFilter?.model)}
              renderValue={() => {
                if (dealerModel.length === 0) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Model
                    </span>
                  );
                }
                return dealerModel.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search Model"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={handleModelsSearch}
                  />
                </div>
                <div className="selectoption_list_content">
                  {filteredModels?.map((models, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={dealerModel.includes(String(models))}
                            onChange={() => {
                              handleFilterSelection(String(models), 'models');
                            }}
                          />
                        }
                        label={models}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Category</p>
            <Select
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              displayEmpty
              value={dealerCategory}
              onClose={handleGetCategory}
              renderValue={() => {
                if (dealerCategory.length === 0) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Category
                    </span>
                  );
                }
                return dealerCategory.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search Category"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={handleCategorySearch}
                  />
                </div>
                <div className="selectoption_list_content">
                  {filteredCategory?.map((category, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={dealerCategory.includes(String(category))}
                            onChange={() => {
                              handleFilterSelection(
                                String(category),
                                'category',
                              );
                            }}
                          />
                        }
                        label={category}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Subcategory</p>
            <Select
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              displayEmpty
              disabled={filterStoreSubCategory?.length == 0}
              value={dealerSubcategory}
              onClose={handleGetSubCategory}
              renderValue={() => {
                if (dealerSubcategory.length === 0) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Subcategory
                    </span>
                  );
                }
                return dealerSubcategory.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search Subcategory"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={handleSubCategorySearch}
                  />
                </div>
                <div className="selectoption_list_content">
                  {filteredSubCategory?.map((subCategory, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={dealerSubcategory.includes(
                              String(subCategory),
                            )}
                            onChange={() => {
                              handleFilterSelection(
                                String(subCategory),
                                'subCategory',
                              );
                            }}
                          />
                        }
                        label={subCategory}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>
        </div>
      </div>
      <div className="create_controller-nodata_drawer_button_content">
        <div className="create_controller-nodata_drawer_button">
          <Button
            variant="text"
            className="cencel_button"
            onClick={fliterCloseDrawer}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleFilterEquipment}
            className={
              isFilterActive ? 'save_button' : 'save_button disabled_button'
            }
            disabled={!isFilterActive}
          >
            Apply
          </Button>
        </div>
      </div>
    </div>
  );
};

const MemoizedComponent = React.memo(EquipmentFilter);
export default MemoizedComponent;
